import { map } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class ReleaseNoteAuthorFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  releases$ = this.store.select(FlatStates.ReleaseNoteAuthorState.releases$)
  currentRelease$ = (version: string) => this.store.select(FlatStates.ReleaseNoteAuthorState.currentRelease$).pipe(map(filterFn => filterFn(version)));

  //</editor-fold>

  //<editor-fold desc="Requests">

  requestGetReleaseNotes() {
    return this.store.dispatch(new FlatActions.ReleaseNoteAuthorActions.GetReleaseNotes());
  }

  //</editor-fold>

}
